import React, { FC, useEffect } from 'react'

import { useNoOverflow } from '../../hooks/useNoOverflow'
import useLastFocus from '../../hooks/useLastFocus'

import * as SC from './styled'

export type ModalProps = {
  className?: string
  isOpen?: boolean
  onClose?: () => void
  children?: React.ReactNode
}

const Modal: FC<ModalProps> = ({ className, isOpen = false, onClose, children }) => {
  useNoOverflow(isOpen)
  useLastFocus(isOpen)
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        onClose?.()
      }
    }
    if (isOpen) window.addEventListener('keyup', handleKey)

    return () => {
      window.removeEventListener('keyup', handleKey)
    }
  }, [isOpen, onClose])

  return (
    <SC.Container className={className} $isOpen={isOpen} aria-hidden={!isOpen}>
      <SC.Background onClick={onClose} />
      <SC.Content>{children}</SC.Content>
    </SC.Container>
  )
}

export default Modal
